import { styled, Box } from "@mui/material";
import { ENV_COLORS } from "../../../styles/theme";

export const SideMenuBox = styled(Box)(({ env }) => ({
    backgroundColor: ENV_COLORS[env] || ENV_COLORS.default,
    color: "#fff", // optional text color for contrast
    padding: "16px"
}));
